import cashReportApi from "../../api/cash/cashReportApi";

const CashReportService = {

    /**
     * 📊 Obtener Corte X (sesión activa)
     *
     * GET /api/cash/reports/x
     */
    getXReport: async () => {
        const response = await cashReportApi.fetchCustom(`/x`);
        return response.data;
    }

};

export default CashReportService;